export type NavigationOptions = {
  replace?: boolean;
};

type NavigationLogEntry = {
  url: string;
  options?: NavigationOptions;
};

declare global {
  interface Window {
    __testNavigations?: NavigationLogEntry[];
  }
}

function logTestNavigation(url: string, options?: NavigationOptions) {
  if (typeof window === 'undefined') {
    return;
  }
  window.__testNavigations = window.__testNavigations || [];
  window.__testNavigations.push({ url, options });
}

export function redirectTo(url: string, options?: NavigationOptions) {
  if (typeof window === 'undefined') {
    return;
  }

  if (process.env.NODE_ENV === 'test') {
    logTestNavigation(url, options);
    return;
  }

  if (options?.replace && typeof window.location.replace === 'function') {
    window.location.replace(url);
    return;
  }

  window.location.href = url;
}
